import React from 'react'
import pdf from '../../../../static/manual_de_servicio.pdf'

function ManualDeServicio () {
  return (
    <iframe
      title='manualdeservicio'
      src={pdf}
      style={{ width: '100%', minHeight: '85vh', marginTop: '-2%' }}
    />
  )
}

export default ManualDeServicio
